import axiosClient from "../../../../system/helpers/axiosConfig";

export const API_KEY_GET_ADMIN_TOTALS = "API_KEY_GET_ADMIN_TOTALS";
export const getTotals = (params) => {
  return axiosClient
    .get("/api/admin/dashboard/totals", { params })
    .then((r) => r.data);
};
